// extracted by mini-css-extract-plugin
module.exports = {"container":"CardHeader_container__vAHLd","titleAndIcon":"CardHeader_titleAndIcon__TF_ez","title":"CardHeader_title__wTqk_","icon":"CardHeader_icon__xxD3z"};